import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ExperienceWidget } from './experience-widget.model';

export class ExperienceWidgetStateModel extends EntityStateModel<ExperienceWidget> {}
